<profile-avatar size="big" [image]=image [name]="name" [surname]="surname"></profile-avatar>
<div (click)="linkClick()" matRipple class="actionable padding-top-8">{{name}} {{surname}}</div>
<i class="description-profile">{{description}}</i>
